/*
 * @Author: Dom
 * @Date: 2022-05-18 18:15:06
 * @LastEditTime: 2022-05-25 16:14:52
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal-center\component\password\locales\en-US.ts
 */
export default {
    'page.personal.center.compontent.oldpassword.tips' : 'Enter the original password',
    'page.personal.center.compontent.newpassword.tips' : 'Set new password',
    'page.personal.center.compontent.confirmpassword.tips' : 'Confirm new password',
    'page.personal.center.compontent.psd.btnconfirm' : 'Confirm modification',
    'page.personal.center.compontent.btnctrl' : 'Cance',
    'page.personal.center.compontent.txtstart' : 'Password modified successfully，',
    'page.personal.center.compontent.txtend' : 'It will automatically jump to the login page in seconds...',
    'page.personal.center.compontent.login' : 'Login',
}
